<template>
  <div >
    <b-container fluid class="md-content">
        <div class="md-header">Plan Typen</div>
        <b-card>
            <b-row>
                <b-col>
                    <b-button variant="success" @click="showModal('modal-createemployeetype')">Plan Typ anlegen</b-button>
                </b-col>
                
                <b-col>
                    <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-if="types != undefined">
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="types" :fields="fields">
                        
                        <template slot="actions" slot-scope="row">
                            <b-button class="mx-1" size="sm" v-on:click="openViewModal(row.item.id)"><i class="fas fa-eye"></i></b-button>
                            <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteModal(row)"><i class="fas fa-trash"></i></b-button>
                        </template>
                        
                    </b-table>
                </b-col>
            </b-row>
        </b-card>
    </b-container>

    

    <b-modal ref="modal-createemployeetype"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Plantyp anlegen" @cancel="hideModal('modal-createemployeetype')" @ok="createEmployeeType" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Name" label-for="cet0">
                        <b-form-input id="cet0" v-model="employeeType.name" type="text"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Vorlage" label-for="ctfield1">
                    <b-form-select id = "ctfield1" v-model="employeeTypeTemplateId" @change="onChangeEmployeeTypeTemplate">
                        <option v-bind:key ="1" v-bind:value="null">
                            Keine Vorlage
                        </option>
                         <option v-for="option in employeeTypeTemplateMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <div v-if="employeeTypeTemplateId != null && employeeTypeTemplateMap[employeeTypeTemplateId] != null">
                    <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Monats Soll-Stunden" label-for="ctfield14" :description="''+employeeType.monthTimeRegular">
                        <b-form-input  :min="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].monthTimeRegularMin/60)" :max="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].monthTimeRegularMax/60)" id="ctfield14" v-model.number="employeeType.monthTimeRegular" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Planungstyp" label-for="ctfield15">
                        <b-form-select disabled id = "ctfield15" v-model.number="employeeType.monthTimeMaxType">
                            <option value="1">Monats Sollstunden dürfen bei der Planung beliebig überschritten werden</option>
                            <option value="2">Monats Sollstunden dürfen bei der Planung max. um einen festen Betrag überschritten werden</option>
                            <option value="3">Monats Sollstunden dürfen bei der Planung nicht überschritten werden</option>
                        </b-form-select>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Monats-Soll Buffer" label-for="ctfield16" v-if="employeeType.monthTimeMaxType===2" :description="''+employeeType.monthTimeMaxAdjustment">
                        <b-form-input :min="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].monthTimeMaxAdjustmentMin/60)" :max="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].monthTimeMaxAdjustmentMax/60)" id="ctfield16" v-model.number="employeeType.monthTimeMaxAdjustment" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Soll-Stunden" label-for="ctfield17" :description="''+employeeType.weekTimeRegular">
                        <b-form-input  :min="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].weekTimeRegularMin/60)" :max="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].weekTimeRegularMax/60)" id="ctfield17" v-model.number="employeeType.weekTimeRegular" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Max-Stunden" label-for="ctfield18" :description="''+employeeType.weekTimeMax">
                        <b-form-input  :min="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].weekTimeMaxMin/60)" :max="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].weekTimeMaxMax/60)" id="ctfield18" v-model.number="employeeType.weekTimeMax" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen-Durchnitt Typ" label-for="ctfield4b">
                        <b-form-select disabled id = "ctfield4b" v-model.number="employeeType.weekTimeAvgType">
                            <option value="1">Wochen Durchschnitt Sollstunden können bei der Planung ignoriert werden</option>
                            <option value="2">Wochen Durchschnitt Sollstunden sollen möglichst nah an den Wochen Sollstunden liegen</option>
                            <option value="3">Wochen Durchschnitt Sollstunden dürfen Wochen Sollstunden nicht überschreiten</option>
                        </b-form-select>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Soll-Arbeitstage" label-for="ctfield19" :description="''+employeeType.weekWorkDaysRegular">
                        <b-form-input  :min="employeeTypeTemplateMap[employeeTypeTemplateId].weekWorkDaysRegularMin" :max="employeeTypeTemplateMap[employeeTypeTemplateId].weekWorkDaysRegularMax" id="ctfield19" v-model.number="employeeType.weekWorkDaysRegular" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Tages Soll-Stunden" label-for="ctfield20" :description="''+employeeType.dayTimeRegular">
                        <b-form-input  :min="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].dayTimeRegularMin/60)" :max="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].dayTimeRegularMax/60)" id="ctfield20" v-model.number="employeeType.dayTimeRegular" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Tages Max-Stunden" label-for="ctfield21" :description="''+employeeType.dayTimeMax">
                        <b-form-input  :min="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].dayTimeMaxMin/60)" :max="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].dayTimeMaxMax/60)" id="ctfield21" v-model.number="employeeType.dayTimeMax" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Ruhezeit" label-for="ctfield22" :description="''+employeeType.restTime">
                        <b-form-input  :min="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].restTimeMin/60)" :max="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].restTimeMax/60)" id="ctfield22" v-model.number="employeeType.restTime" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freizeit / Woche in Tagen" label-for="ctfield23" :description="''+employeeType.weekSpareDaysMin">
                        <b-form-input  :min="employeeTypeTemplateMap[employeeTypeTemplateId].weekSpareDaysMinMin" :max="employeeTypeTemplateMap[employeeTypeTemplateId].weekSpareDaysMinMax" id="ctfield23" v-model.number="employeeType.weekSpareDaysMin" type="range"></b-form-input>
                    </b-form-group>
                    
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Zusätzliche Freizeit in Stunden" label-for="ctfield24" :description="''+employeeType.weekAdditionalSpareTime">
                        <b-form-input  disabled min="0" max="24" id="ctfield24" v-model.number="employeeType.weekAdditionalSpareTime" type="range"></b-form-input>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freizeit Beginn Typ" label-for="ctfield38">
                        <b-form-select disabled id = "ctfield38" v-model.number="employeeType.weekSpareTimeStartType">
                            <option value="1">Mindest Wochen Freizeit kann zu jeder Uhrzeit beginnen</option>
                            <option value="2">Mindest Wochen Freizeit soll möglichst nahe an Ziel Uhrzeit beginnen</option>
                            <option value="3">Mindest Wochen Freizeit muss vor Ziel Uhrzeit beginnen</option>
                        </b-form-select>
                    </b-form-group>

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freizeit Ziel Uhrzeit" label-for="ctfield39" v-if="employeeType.weekSpareTimeStartType === 2 || employeeType.weekSpareTimeStartType === 3" >
                        <b-form-input id="ctfield39" v-model="employeeType.weekSpareTimeStart" type="time"></b-form-input>
                    </b-form-group>

                   
                    <div v-if="employeeType.allowMultipleShifts">
                        <h4 >Mehrere Schichten/Tag</h4>
                           
                        <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Min. Zeit zwischen Schicht" label-for="ctfield26" :description="''+employeeType.shiftBetweenTimeMin">
                            <b-form-input  :min="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].shiftBetweenTimeMinMin/60)" :max="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].shiftBetweenTimeMinMax/60)" id="ctfield26" v-model.number="employeeType.shiftBetweenTimeMin" type="range"></b-form-input>
                        </b-form-group>

                        <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Zeit zwischen Schicht" label-for="ctfield27" :description="''+employeeType.shiftBetweenTimeMax">
                            <b-form-input  :min="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].shiftBetweenTimeMaxMin/60)" :max="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].shiftBetweenTimeMaxMax/60)" id="ctfield27" v-model.number="employeeType.shiftBetweenTimeMax" type="range"></b-form-input>
                        </b-form-group>
                    </div>

                    <div v-if="employeeType.limitConsecutiveDays">
                        <h4 >Aufeinander folgende Arbeitstage begrenzen</h4>
                        
                        <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. aufeinander folgende Arbeitstage" label-for="ctfield29" :description="''+employeeType.daysConsecutiveMax">
                            <b-form-input  :min="employeeTypeTemplateMap[employeeTypeTemplateId].consecutiveDaysMaxMin" :max="employeeTypeTemplateMap[employeeTypeTemplateId].consecutiveDaysMaxMax" id="ctfield29" v-model.number="employeeType.daysConsecutiveMax" type="range"></b-form-input>
                        </b-form-group>
                    </div> 
                    
                    <div v-if="employeeType.limitOvertime">
                        <h4 >Überstunden begrenzen</h4>
                        
                        <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Überstunden / Monat" label-for="ctfield31" :description="''+employeeType.monthOvertimeMax">
                            <b-form-input  :min="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].monthOvertimeMaxMin/60)" :max="Math.floor(employeeTypeTemplateMap[employeeTypeTemplateId].monthOvertimeMaxMax/60)" id="ctfield31" v-model.number="employeeType.monthOvertimeMax" type="range"></b-form-input>
                        </b-form-group>
                    </div>

                   <div v-if="employeeType.useWorkDaysForSpareTime">
                        <h4 >Arbeitstage / Woche begrenzen</h4>
                        <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Arbeitstage/Woche" label-for="ctfield33" :description="''+employeeType.weekWorkDaysMax">
                            <b-form-input  :min="employeeTypeTemplateMap[employeeTypeTemplateId].weekWorkDaysMaxMin" :max="employeeTypeTemplateMap[employeeTypeTemplateId].weekWorkDaysMaxMax" id="ctfield33" v-model.number="employeeType.weekWorkDaysMax" type="range"></b-form-input>
                        </b-form-group>
                   </div>
                    

                </div>

            </div>
           
            <b-row v-if="typeerror">
                Fehler beim Erstellen des Plan Typen.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-deleteemployeetype"  no-close-on-backdrop no-close-on-esc centered title="Plan Typ löschen" @cancel="hideModal('modal-deleteemployeetype')" @ok="deleteEmployeeType" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row>
                <p> Sind Sie sicher dass Sie den Plan Typ des Mitarbeiters löschen wollen?</p>
            </b-row>
            <b-row v-if="typeerror">
                Fehler beim Löschen des Plan Typ.
            </b-row>
        </b-container>
    </b-modal>


   <b-modal ref="modal-viewemployeetype"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Plan Type Detail" @cancel="hideModal('modal-viewemployeetype')" @ok="hideModal('modal-viewemployeetype')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>
                <b-tab title="Plan-Typ">
                   
                    <div v-if="employeeTypeId != undefined && employeeTypeMap[employeeTypeId] != undefined">
                        <b-row v-if="employeeTypeMap[employeeTypeId].templateId != undefined && employeeTypeTemplateMap[employeeTypeMap[employeeTypeId].templateId] != undefined">
                            <b-col class="md-2">
                                <b>Muster:</b>
                            </b-col>
                            <b-col>
                                {{employeeTypeTemplateMap[employeeTypeMap[employeeTypeId].templateId].name}}
                            </b-col>
                            
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Monats-Soll:</b>
                            </b-col>
                            <b-col>
                                {{employeeTypeMap[employeeTypeId].monthTimeRegular/60}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Wochen-Soll:</b>
                            </b-col>
                            <b-col>
                               {{employeeTypeMap[employeeTypeId].weekTimeRegular/60}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Tages-Soll:</b>
                            </b-col>
                            <b-col>
                                {{employeeTypeMap[employeeTypeId].dayTimeRegular/60}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Ruhezeit:</b>
                            </b-col>
                            <b-col>
                               {{employeeTypeMap[employeeTypeId].restTime/60}}
                            </b-col>
                        </b-row>
                        
                    </div>
                </b-tab>
            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>

  </div> 

</template>

<script>
export default {
  name: 'employeetypeoverview',
  data () {
    return {
      types: [],
      employeeTypeMap: {},
      employeeTypeTemplateMap: {},
      fields: [{key:"name", label:"Name", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key:"actions", label: "", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: false}],

      employeeTypeId: undefined,
      employeeTypeTemplateId: null,
      employeeType: {
          name: "",
          monthTimeRegular: 173,
          monthTimeMaxType: 1,
          monthTimeMaxAdjustment: 0,
          weekTimeMax: 60,
          weekTimeRegular: 40,
          dayTimeMax: 12,
          dayTimeRegular: 8,
          restTime: 11,
          allowMultipleShifts: false,
          shiftBetweenTimeMin: 0,
          shiftBetweenTimeMax: 3,
          limitConsecutiveDays: false,
          daysConsecutiveMax: 6,
          limitOvertime: false,
          monthOvertimeMax: 20,
          overtimeCutoff: 480,
          useWorkDaysForSpareTime: false,
          weekWorkDaysMax: 1,
          weekWorkDaysRegular: 5,
          weekSpareDaysMin: 1,
          weekAdditionalSpareTime: 12,
          weekTimeAvgType: 1,
          weekSpareTimeStartType: 1,
          weekSpareTimeStart: null,
      },
      
      currentTypeRow: {},
      typeerror: false,
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function(){
        let view = this;

        this.loadEmployeeTypeTemplates()
        .then(response => {
            view.updateEmployeeTypeTemplates(response.data);
            view.loadEmployeeTypes()
            .then(response => {
                view.updateEmployeeTypes(response.data);
            }).catch(function (error) {
                console.log(error)
            })
        }).catch(function (error) {
            console.log(error)
        })
    },
    
    onChangeEmployeeTypeTemplate: function (val) {
        
        if(val != null && this.employeeTypeTemplateMap[val] != null){
            this.employeeType = {
                name: this.employeeType.name,
                monthTimeRegular: Math.floor(this.employeeTypeTemplateMap[val].monthTimeRegularMin/60),
                monthTimeMaxType: this.employeeTypeTemplateMap[val].monthTimeMaxType,
                monthTimeMaxAdjustment: Math.floor(this.employeeTypeTemplateMap[val].monthTimeMaxAdjustmentMin/60),
                weekTimeMax: Math.floor(this.employeeTypeTemplateMap[val].weekTimeMaxMin/60),
                weekTimeRegular: Math.floor(this.employeeTypeTemplateMap[val].weekTimeRegularMin/60),
                dayTimeMax: Math.floor(this.employeeTypeTemplateMap[val].dayTimeMaxMin/60),
                dayTimeRegular: Math.floor(this.employeeTypeTemplateMap[val].dayTimeRegularMin/60),
                restTime: Math.floor(this.employeeTypeTemplateMap[val].restTimeMin/60),
                allowMultipleShifts: this.employeeTypeTemplateMap[val].shiftBetweenTimeMinMin > -1,
                shiftBetweenTimeMin: Math.floor(this.employeeTypeTemplateMap[val].shiftBetweenTimeMinMin/60),
                shiftBetweenTimeMax: Math.floor(this.employeeTypeTemplateMap[val].shiftBetweenTimeMaxMin/60),
                limitConsecutiveDays: this.employeeTypeTemplateMap[val].consecutiveDaysMaxMin > -1,
                daysConsecutiveMax: this.employeeTypeTemplateMap[val].consecutiveDaysMaxMin,
                limitOvertime: this.employeeTypeTemplateMap[val].monthOvertimeMaxMin > -1,
                monthOvertimeMax: Math.floor(this.employeeTypeTemplateMap[val].monthOvertimeMaxMin/60),
                overtimeCutoff: Math.floor(this.employeeTypeTemplateMap[val].overtimeCutoffMin/60),
                useWorkDaysForSpareTime: this.employeeTypeTemplateMap[val].weekWorkDaysMaxMin > -1,
                weekWorkDaysMax: this.employeeTypeTemplateMap[val].weekWorkDaysMaxMin,
                weekWorkDaysRegular: this.employeeTypeTemplateMap[val].weekWorkDaysRegularMin,
                weekSpareDaysMin: this.employeeTypeTemplateMap[val].weekSpareDaysMinMin,
                weekAdditionalSpareTime: Math.floor(this.employeeTypeTemplateMap[val].weekSpareTimeMinMin/60) - (this.employeeTypeTemplateMap[val].weekSpareDaysMinMin*24),
                weekTimeAvgType: this.employeeTypeTemplateMap[val].weekTimeAvgType,
                weekSpareTimeStartType: this.employeeTypeTemplateMap[val].weekSpareTimeStartType,
                weekSpareTimeStart: this.employeeTypeTemplateMap[val].weekSpareTimeStartMin
            };
        }
    },
    createEmployeeType: function(evt){
        evt.preventDefault();
        this.typeerror=false;
        let view = this;
        let url = '/api/sec/employeetype';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetype');
        let payload = {
          storeId: this.$store.state.storeId,
        }

        payload.name = this.employeeType.name;
        payload.templateId = this.employeeTypeTemplateId;
        payload.monthTimeRegular = this.employeeType.monthTimeRegular*60;
        payload.monthTimeMaxType = this.employeeType.monthTimeMaxType;
        payload.monthTimeMaxAdjustment = this.employeeType.monthTimeMaxAdjustment;
        payload.weekTimeMax = this.employeeType.weekTimeMax*60;
        payload.weekTimeRegular = this.employeeType.weekTimeRegular*60;
        payload.dayTimeRegular = this.employeeType.dayTimeRegular*60;
        payload.dayTimeMax = this.employeeType.dayTimeMax*60;
        payload.restTime = this.employeeType.restTime*60;
        payload.weekWorkDaysRegular = this.employeeType.weekWorkDaysRegular;
        payload.overtimeCutoff = this.employeeType.dayTimeRegular*60;
        payload.weekTimeAvgType = this.employeeType.weekTimeAvgType;
        payload.weekSpareTimeStartType = this.employeeType.weekSpareTimeStartType;
        payload.weekSpareTimeStart = this.employeeType.weekSpareTimeStart;
        if(this.employeeType.allowMultipleShifts){
            payload.shiftBetweenTimeMin = this.employeeType.shiftBetweenTimeMin*60;
            payload.shiftBetweenTimeMax = this.employeeType.shiftBetweenTimeMax*60;
        } else {
            payload.shiftBetweenTimeMin = -1;
            payload.shiftBetweenTimeMax = -1;
        }
        if(this.employeeType.limitConsecutiveDays){
            payload.daysConsecutiveMax = this.employeeType.daysConsecutiveMax;
        } else {
            payload.daysConsecutiveMax = -1;
        }
        if(this.employeeType.limitOvertime){
            payload.monthOvertimeMax = this.employeeType.monthOvertimeMax*60;
        } else {
            payload.monthOvertimeMax = -1;
        }
        if(this.employeeType.useWorkDaysForSpareTime){
            payload.weekWorkDaysMax = this.employeeType.weekWorkDaysMax;
        } else {
            payload.weekWorkDaysMax = -1;
        }
        payload.weekSpareDaysMin = this.employeeType.weekSpareDaysMin;
        payload.weekSpareTimeMin = this.employeeType.weekSpareDaysMin*24*60 + this.employeeType.weekAdditionalSpareTime*60;
        payload.weekSpareTimeStartType = this.employeeType.weekSpareTimeStartType;
        if(payload.weekSpareTimeStartType == 1){
            payload.weekSpareTimeStart = null;
        } else {
            payload.weekSpareTimeStart = this.$helpers.extractTimeString(this.employeeType.weekSpareTimeStart);
        }
        
        
        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            let employeeType = response.data.data;
            view.employeeTypeMap[employeeType.id] = employeeType;
            view.types.push(employeeType);
            
           
            view.hideModal('modal-createemployeetype');

        }).catch(function (error) {
            view.typeerror=true;
            console.log(error)
        })

    },
    
   
    
    openDeleteModal: function(row){
        this.currentTypeRow = row;
        this.employeeType.name = row.item.name;
        this.employeeTypeId = row.item.id;
        this.showModal('modal-deleteemployeetype');
    },
    deleteEmployeeType: function(evt){
        evt.preventDefault();
        this.typeerror=false;
        let view = this;
        let url = '/api/sec/employeetype';
        
        url = this.$helpers.appendParam("id", this.employeeTypeId, url, '/api/sec/employeetype');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetype');
        
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.types.findIndex(employeeType => employeeType.id === view.employeeTypeId) // find the employee index 
            if (~index) {
                view.types.splice(index, 1);
            } 
            view.deleteEmployeeTypeFromMap(view.employeeTypeId);
            view.employeeTypeId = undefined;
            view.hideModal('modal-deleteemployeetype');
        }).catch(function (error) {
            view.typeerror=true;
            console.log(error)
        })

    },
    
    
    
    deleteEmployeeTypeFromMap(id){
        delete this.employeeTypeMap[id]
    },
   
    openViewModal: function(id){
        let view = this;
        this.employeeTypeId = id;
        
        
        view.showModal('modal-viewemployeetype');
    },
    
    loadEmployeeTypes : function() {
      
      let url = '/api/sec/employeetype';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetype');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    
    loadEmployeeTypeTemplates : function() {
      
      let url = '/api/sec/employeetypetemplate';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetypetemplate');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    
    updateEmployeeTypeTemplates: function(data){
        
        let templateMap = {};
        for (let i = 0; i < data.length; i++) {
            templateMap[data[i].id] =data[i];
        }
        this.employeeTypeTemplateMap = templateMap;
    },
    
    updateEmployeeTypes: function(data){
        var i;
        let overviewA = [];
        let ttypes = {}
        for (i = 0; i < data.length; i++) {
            ttypes[data[i].id] =data[i];
            overviewA.push(data[i]);
        }
        this.employeeTypeMap = ttypes;
        this.types = overviewA;
    },
   
    hideModalWithoutReset (ref) {
        this.typeerror=false;
        this.$refs[ref].hide();
    },
    
    resetEmployeeTypeValues(){
        this.typeerror=false;
        this.currentTypeRow={};
        this.employeeType = {
          nem: "",
          templateId: null,
          monthTimeRegular: 173,
          monthTimeMaxType: 1,
          monthTimeMaxAdjustment: 0,
          weekTimeMax: 60,
          weekTimeRegular: 40,
          dayTimeMax: 12,
          dayTimeRegular: 8,
          restTime: 11,
          allowMultipleShifts: false,
          shiftBetweenTimeMin: 0,
          shiftBetweenTimeMax: 3,
          limitConsecutiveDays: false,
          daysConsecutiveMax: 6,
          limitOvertime: false,
          monthOvertimeMax: 20,
          overtimeCutoff: 480,
          useWorkDaysForSpareTime: false,
          weekWorkDaysMax: 1,
          weekWorkDaysRegular: 5,
          weekSpareDaysMin: 1,
          weekAdditionalSpareTime: 12,
          weekTimeAvgType: 1,
          weekSpareTimeStartType: 1,
          weekSpareTimeStart: null,
      }
    },
   
   
    hideModal (ref) {
        this.employeeTypeTemplateId = null;
        this.resetEmployeeTypeValues();

        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  computed: {
   
  },
  watch: { 
    
  }

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>

</style>
